<template>
	<div class="grid-flex-container mx-2 pt-6">
		<div class="d-flex" style="overflow-y: hidden">
			<v-col cols="3" class="pa-0">
				<v-list dense style="height: 100%">
					<v-list-item-group
						style="overflow-y: scroll; height: 100%"
						active-class="primary white--text"
						mandatory
						v-model="selectedEntity"
					>
						<v-list-item v-for="(item, i) in entities" :key="i"
							><v-list-item-title>{{
								item.Name
							}}</v-list-item-title>
						</v-list-item>
					</v-list-item-group>
				</v-list>
			</v-col>
			<v-col>
				<div class="searchRow">
					<v-text-field
						v-model="searchFields"
						append-icon="mdi-magnify"
						label="Search"
						class="py-0 my-0 mb-2 mr-2"
						single-line
						hide-details
						clearable
					></v-text-field>
					<v-btn
						v-if="canAdd"
						color="primary"
						@click.stop="addMergeConditionField()"
						class="mb-2 pl-4 pr-6"
					>
						<v-icon> mdi-plus</v-icon>
						&nbsp;&nbsp;Add
					</v-btn>
				</div>

				<v-data-table
					dense
					:headers="headers"
					:items="filteredItems"
					:disable-pagination="true"
					item-key="Id"
					fixed-header
					loading-text="Loading..."
					hide-default-footer
				>
					<template v-slot:[`item.actions`]="{ item }">
						<v-btn
							v-if="canDelete"
							class="action-btn"
							fab
							small
							icon
							elevation="1"
							color="success"
							@click="deleteItem(item)"
						>
							<v-icon color="error" small>mdi-delete</v-icon>
						</v-btn>
					</template>
				</v-data-table>
			</v-col>
		</div>
		<merge-conditions-field-modal
			v-if="showAddDialog"
			:showDialog="showAddDialog"
			:items="availableFields"
			:entityId="entities[this.selectedEntity].Id"
			@close="onAddModalClose"
		/>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { MergeConditionsGetters } from '../../../store/getters';
import { MergeConditionsActions } from '../../../store/actions';
import MergeConditionsFieldModal from './MergeConditionsFieldModal.vue';
import permissionsMixin from '@/mixins/permissionsMixin';
import { Permissions } from '../../../enums/permissionsEnum';
export default {
	name: 'MergeConditions',
	components: {
		MergeConditionsFieldModal,
	},
	mixins: [permissionsMixin],
	computed: {
		...mapGetters({
			fields: [MergeConditionsGetters.MERGE_CONDITION_FIELDS],
			entities: [MergeConditionsGetters.ENTITIES],
			availableFields: [MergeConditionsGetters.AVAILABLE_FIELDS],
		}),
		filteredItems() {
			if (!this.searchFields) return this.fields;
			return this.fields.filter((x) => {
				return (
					x.Label &&
					x.Label.toLowerCase().includes(
						this.searchFields.toLowerCase()
					)
				);
			});
		},
		canAdd() {
			return this.hasPermissions([
				Permissions.Settings.MergeConditions.Add,
			]);
		},
		canDelete() {
			return this.hasPermissions([
				Permissions.Settings.MergeConditions.Delete,
			]);
		},
	},
	destroyed() {
		this.$store.dispatch(MergeConditionsActions.CLEAR);
	},
	data() {
		return {
			selectedEntity: null,
			searchFields: '',
			showAddDialog: false,
			headers: [
				{
					text: 'Label',
					value: 'Label',
					sortable: false,
				},
				{ text: '', value: 'actions', sortable: false, align: 'end' },
			],
		};
	},
	watch: {
		selectedEntity() {
			this.$store.dispatch(
				MergeConditionsActions.LOAD_DEFAULT_GRIDVIEW,
				this.entities[this.selectedEntity].Id
			);
		},
	},
	mounted() {
		this.$store.dispatch(MergeConditionsActions.LOAD_ENTITIES);
	},
	methods: {
		addMergeConditionField() {
			this.showAddDialog = true;
		},
		onAddModalClose() {
			this.showAddDialog = false;
		},
		deleteItem(item) {
			this.$store.dispatch(
				MergeConditionsActions.DELETE_MERGE_CONDITION_FIELD,
				item
			);
		},
	},
};
</script>
<style>
.searchRow {
	display: flex;
	flex-direction: row;
}
.col {
	padding: 0px;
}
</style>
